// @ts-nocheck
import * as React from 'react';
import $ from 'jquery';
import lodashfilter from 'lodash/filter';

import NormalCC from '../images/Status/Alarms/NormalCC.png';
import MediumCC from '../images/Status/Alarms/MediumCC.png';
import LowCC from '../images/Status/Alarms/LowCC.png';
import HighCC from '../images/Status/Alarms/HighCC.png';
import HighALM from '../images/Status/Alarms/HighALM.png';
import MediumALM from '../images/Status/Alarms/MediumALM.png';

import PlugSolid from '../images/PlugSolid.svg';
import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import batterynormal from '../images/battery-normal.svg';
import BatteryIndicator from '../images/BatteryIndicator.svg';
import DualColorBattery from '../images/DualColorBattery.svg';

import TripInprogress from '../images/Status/RouteDeviation/TripInprogress.png';
import TripCompletedDeviation from '../images/Status/RouteDeviation/TripCompletedDeviation.png';
import TripCompleted from '../images/Status/RouteDeviation/TripCompleted.png';
import TripProblemetic from '../images/Status//RouteDeviation/TripProblemetic.png';
import TripPending from '../images/Status/RouteDeviation/TripPending.png';
import TripDeleted from '../images/Status/RouteDeviation/TripDeleted.png';
import TripCancelDeviation from '../images/Status/RouteDeviation/TripCancelDeviation.png';
import TripCancel from '../images/Status/RouteDeviation/TripCancel.png';
import UnknownStatus from '../images/Status/UnknownStatus.png';
import ErrorStatus from '../images/Status/ErrorStatus.png';
import PendingStatus from '../images/Status/PendingStatus.png';
import IssuedStatus from '../images/Status/IssuedStatus.png';
import ExpiredStatus from '../images/Status/ExpiredStatus.png';
import CancelStatus from '../images/Status/CancelStatus.png';
import SucessStatus from '../images/Status/SucessStatus.png';
import AcceptedStatus from '../images/Status/AcceptedStatus.png';
import RejectedStatus from '../images/Status/RejectedStatus.png';
import DiscardedStatus from '../images/Status/DiscardedStatus.png';
import RetryStatus from '../images/Status/RetryStatus.png';
import AcceptedByBusyRCDStatus from '../images/Status/AcceptedByBusyRCDStatus.png';
import AwaitingPrerequisites from '../images/Status/AwaitingPrerequisites.png';
import CancellationRequest from '../images/Status/CancellationRequest.png';
import SendToVC from '../images/Status/SendToVC.png';
import ValidationPendingStatus from '../images/Status/ValidationPendingStatus.png';
import UndeliverableStatus from '../images/Status/UndeliverableStatus.png';
import AssetStateActive from '../images/AssetState/ActiveRA.svg';
import AssetStateDisconnected from '../images/AssetState/DisconnectedRA.png';
import AssetStateRetired from '../images/AssetState/RetiredRA.svg';


import DBP0 from '../images/DoorBattPct/0.svg';
import DBP10 from '../images/DoorBattPct/10.svg';
import DBP20 from '../images/DoorBattPct/20.svg';
import DBP30 from '../images/DoorBattPct/30.svg';
import DBP40 from '../images/DoorBattPct/40.svg';
import DBP50 from '../images/DoorBattPct/50.svg';
import DBP60 from '../images/DoorBattPct/60.svg';
import DBP70 from '../images/DoorBattPct/70.svg';
import DBP80 from '../images/DoorBattPct/80.svg';
import DBP90 from '../images/DoorBattPct/90.svg';
import DBP100 from '../images/DoorBattPct/100.svg';

import RSSIUNK from '../images/RSSI/RSSI_UNK.png';
import RSSI1 from '../images/RSSI/RSSI_1.png';
import RSSI2 from '../images/RSSI/RSSI_2.png';
import RSSI3 from '../images/RSSI/RSSI_3.png';
import RSSI4 from '../images/RSSI/RSSI_4.png';
import RSSI5 from '../images/RSSI/RSSI_5.png';

import GroupChat from '../images/GroupChat.png';
import ImgPending1 from '../images/Img_Pending1.png';
import ImgWarning1 from '../images/Img_Warning1.png';
import ImgSuccess1 from '../images/Img_Success1.png';
import deletepng from '../images/delete.png';

import bulletcommand from '../images/bullet_command.png';

export class ReeferCellRenderer extends React.Component {
    constructor(props: any) {
        super(props);
    }

    static RunStateFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.RunState != null && params.data.RunState != undefined) {
                if ((params.data.RunState.toString().toUpperCase().trim()) == 'I')
                    return <span title="Running" className="fas fa-power-off GridIcons greenText" > </span>;

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'S')
                    return <span title="Standby" className="fas fa-power-off GridIcons greytext" > </span>;

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'X')
                    return <span title="Faulty" className="fas fa-power-off GridIcons orangetext" > </span>;


                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'O')
                    return <span title="Offline" className="fas fa-horizontal-rule" > </span>;

                else
                    return '-NA-';

            }

            return '-NA-';
        }
    }
    static GetCargoCareAlmImg(almIcon) {

        if (almIcon == "") {
            return "";
        }      
        else if (almIcon == "1") {
            //return '<img  border="0" width="20" height="20" src="../../images/HighCC.png" />'
            var imageHighCCElement = document.createElement("img");
            imageHighCCElement.src = HighCC;
            return imageHighCCElement;
        }
        else if (almIcon == "2") {
            //return '<img  border="0" width="20" height="20" src="../../images/MediumCC.png" />'
            var imageMediumCCElement = document.createElement("img");
            imageMediumCCElement.src = MediumCC;
            return imageMediumCCElement;
        }
        else if (almIcon == "3") {
            //return '<img  border="0" width="20" height="20" src="../../images/LowCC.png" />'
            var imageLowCCElement = document.createElement("img");
            imageLowCCElement.src = LowCC;
            return imageLowCCElement;
        }
    }
    static CargoCareFormatter(params) {

        if (params != null && params != undefined && params != '') {

            var cellColor = "";
            var isCargoCare = false;

            if (params.data != null && params.data != undefined && params.data != '') {
                isCargoCare = params.data.IsCargoCare;

                if (params.data.CCAlarms != "" && params.data.CCAlarms != null && params.data.CCSeverityLevel != "" && params.data.CCSeverityLevel != null) {
                    if (params.data.CCSeverityLevel.toString() == "1") {
                        cellColor = "Tomato";
                    }
                    else if (params.data.CCSeverityLevel.toString() == "2") {
                        cellColor = "Orange";
                    }
                    else if (params.data.CCSeverityLevel.toString() == "3") {
                        cellColor = "Yellow";
                    }
                }
                else {
                    cellColor = "";
                }

                if (cellColor == "" && !isCargoCare) {
                    return "";
                }
                else if (isCargoCare && cellColor == "") {
                    return <span className="reefer-alert"><img src={NormalCC}></img></span>;
                }
                else if (isCargoCare && cellColor == "Tomato") {
                    return <span className="reefer-alert"><img src={HighCC}></img></span>;
                }
                else if (isCargoCare && cellColor == "Orange") {
                    return <span className="reefer-alert"><img src={MediumCC}></img></span>;
                }
                else if (isCargoCare && cellColor == "Yellow") {
                    return <span className="reefer-alert"><img src={LowCC}></img></span>;
                }
            }

        }

        return <span className="reefer-alert"></span>;
    }

    static StatusIndicatorWithDescriptionForALM(params) {
        //var element = document.createElement("span");
        //element.className = "reefer-alert";
        if (params.value != null && params.value != undefined && params.value != '') {
            //var imageElement = document.createElement("img");

            //switch (params.value.trim()) {
            //    case '1':
            //        imageSrc = HighALM;
            //        break;
            //    case '2':
            //        imageSrc = MediumALM;
            //        break;
            //    default:
            //        return "";

            //}
            var alarmsList = params.colDef.refData;
            if (params.value.trim() == '1' || params.value.trim() == '2') {
                if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                    if (params.data != null && params.data != undefined) {
                        var lstAlerts = params.data.AlarmsList.split(',');
                        var _alarmsList = "";
                        $.each(lstAlerts, function (index, item) {
                            if (item != "" && item != null) {
                                if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                    var alarmDescription = alarmsList.filter(e =>
                                        e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                }
                                else {
                                    var alarmDescription = alarmsList.filter(e =>
                                        e.AlarmAlias === item);
                                }
                                //var anchorElement = document.createElement("span");
                                var _alarmDesc = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                _alarmsList = _alarmsList != "" ? _alarmsList + "\n" + item + " - " + _alarmDesc : item + " - " + _alarmDesc;
                                //imageElement.title = _alarmsList;
                            }
                        });
                        if (params.value.trim() == '1')
                            return <span className="reefer-alert"><img src={HighALM} title={_alarmsList}></img></span>;
                        else if (params.value.trim() == '2')
                            return <span className="reefer-alert"><img src={MediumALM} title={_alarmsList}></img></span>;

                    }
                }
            }
            return <span className="reefer-alert"></span>;
        }

        return <span className="reefer-alert"></span>;
    }

    static StatusIndicatorWithDescriptionForAlarms(params:any, lstAlarms:any) {
        //var element = document.createElement("span");
        //element.className = "reefer-alert";
        if (params.value != null && params.value != undefined && params.value != '') {
            //var imageElement = document.createElement("img");

            //switch (params.value.trim()) {
            //    case '1':
            //        imageSrc = HighALM;
            //        break;
            //    case '2':
            //        imageSrc = MediumALM;
            //        break;
            //    default:
            //        return "";

            //}
            var alarmsList = lstAlarms;
            if (params.value.trim() == '1' || params.value.trim() == '2') {
                if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                    if (params.data != null && params.data != undefined) {
                        var lstAlerts = params.data.AlarmsList.split(',');
                        var _alarmsList = "";
                        $.each(lstAlerts, function (index, item) {
                            if (item != "" && item != null) {
                                if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                    var alarmDescription = alarmsList.filter(e =>
                                        e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                }
                                else {
                                    var alarmDescription = alarmsList.filter(e =>
                                        e.AlarmAlias === item);
                                }
                                //var anchorElement = document.createElement("span");
                                var _alarmDesc = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                _alarmsList = _alarmsList != "" ? _alarmsList + "\n" + item + " - " + _alarmDesc : item + " - " + _alarmDesc;
                                //imageElement.title = _alarmsList;
                            }
                        });
                        if (params.value.trim() == '1')
                            return <span className="reefer-alert"><img src={HighALM} title={_alarmsList}></img></span>;
                        else if (params.value.trim() == '2')
                            return <span className="reefer-alert"><img src={MediumALM} title={_alarmsList}></img></span>;

                    }
                }
            }
            return <span className="reefer-alert"></span>;
        }

        return <span className="reefer-alert"></span>;
    }

    static PwrStateFormatter(params) {

        if (params.data != null && params.data != undefined) {
            if (params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "GT1200") {
                if (params.data.AssetType != null && params.data.AssetType != undefined && params.data.AssetType.toString().toUpperCase().trim() == "C") {
                    if (params.data.ChassisPWR != null && params.data.ChassisPWR != undefined && params.data.ChassisPWR.toString().toUpperCase().trim() == "A") {
                        return <span className="PlugSolid" title="Powered"><img src={PlugSolid}></img></span>;
                    }
                    else {
                        if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                            if (params.data.DevicePowerSourceCd == "C") {

                                return <span className="pwr_grid_icon" title="Critical"><img src={batterycritical}></img></span>;
                            }
                            else if (params.data.DevicePowerSourceCd == "L") {

                                return <span className="pwr_grid_icon" title="Low"><img src={batterylow}></img></span>;
                            }
                            else if (params.data.DevicePowerSourceCd == "N") {

                                return <span className="pwr_grid_icon" title="Normal"><img src={batterynormal}></img></span>;
                            }
                        }
                    }
                }
                else {
                    if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                        if (params.data.DevicePowerSourceCd == "C") {

                            return <span className="pwr_grid_icon" title="Critical"><img src={batterycritical}></img></span>;
                        }
                        else if (params.data.DevicePowerSourceCd == "L") {

                            return <span className="pwr_grid_icon" title="Low"><img src={batterylow}></img></span>;
                        }
                        else if (params.data.DevicePowerSourceCd == "N") {

                            return <span className="pwr_grid_icon" title="Normal"><img src={batterynormal}></img></span>;
                        }
                    }
                }
            }
            else if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                if (params.data.DevicePowerSourceCd == "B") {

                    return <span className="BatteryIndicator" title="On Battery"><img src={BatteryIndicator}></img></span>;
                }
                else if (params.data.DeviceConfig.toString().toUpperCase().trim() == "TRUE" && params.data.DevicePowerSourceCd == "A") {

                    return <span className="DualColorBattery" title="Charging"><img src={DualColorBattery}></img></span>;
                }
                else {

                    return <span className="PlugSolid" title="Powered"><img src={PlugSolid}></img></span>;
                }
            }

        }

        return '-NA-';
    }

    static TripstatusIndicator(params){
        var deviationFlg = '';
        if (params.value != null && params.value != undefined && params.value != '' && params.value != '-NA-') {

            //var imageSrc = '';
            var valueString = params.value.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        //imageSrc = TripInprogress;
                        return <span className="reefer-alert"><img src={TripInprogress}></img></span>;
                    //break;
                    case 'C':
                        if (deviationFlg == "True")
                            //imageSrc = TripCompletedDeviation; /* WI19591 checking Trip is deviated */
                            return <span className="reefer-alert"><img src={TripCompletedDeviation}></img></span>;
                        else
                            //imageSrc = TripCompleted;
                            return <span className="reefer-alert"><img src={TripCompleted}></img></span>;
                    //break;
                    case 'D':
                        //imageSrc = TripProblemetic;
                        return <span className="reefer-alert"><img src={TripProblemetic}></img></span>;
                    //break;
                    case 'P':
                        //imageSrc = TripPending;
                        return <span className="reefer-alert"><img src={TripPending}></img></span>;
                    //break;
                    case 'R':
                        //imageSrc = TripDeleted;
                        return <span className="reefer-alert"><img src={TripDeleted}></img></span>;
                    //break;
                    case 'X':
                        if (deviationFlg == "True")
                            //imageSrc = TripCancelDeviation; /* WI19591 checking Trip is deviated */
                            return <span className="reefer-alert"><img src={TripCancelDeviation}></img></span>;
                        else
                            //imageSrc = TripCancel;
                            return <span className="reefer-alert"><img src={TripCancel}></img></span>;
                    //break;
                    default:
                        break;

                }
            }

            return <span className="reefer-alert"></span>;

        }
        return <span className="reefer-alert"></span>;
    }

    static AssetStateFormatter(params){
        //var element = document.createElement("span");

        if (params.data != null && params.data != undefined) {
            //var imageElement = document.createElement("img");
            var assetState = params.data.AssetState;
            if (params.data.AssetState != null && params.data.AssetState != undefined) {
                if (assetState.toUpperCase().trim() == 'A') {
                    return <span className="ActiveRA" title="Active"><img src={AssetStateActive}></img></span>;
                }
                else if (assetState.toUpperCase().trim() == 'D') {
                    return <span className="DisconnectedRA" title="Disconnected"><img src={AssetStateDisconnected}></img></span>;
                }
                else if (assetState.toUpperCase().trim() == 'R') {
                    return <span className="RetiredRA" title="Retired"><img src={AssetStateRetired}></img></span>;
                }
            }
        }

        return '-NA-';
    }

    static StringTypeValueFormatter(params) {
        if (params.value != "-NA-") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static OEMPTITypeFormatter(params) {
        var returnValue = '';

        if (params.value != "-NA-") {

            returnValue = params.value.toUpperCase().trim() == "FULLPTI" ? "Full PTI" : params.value.toUpperCase().trim() == "SHORTPTI" ? "Short PTI" : params.value;

            return <span title={returnValue}>{returnValue}</span>;
        }
        else
            return '-NA-';       
    }
    static StringTypeCommodityValueFormatter(params) {
        if (params.value != "-NA-" && params.value != null) {
            if (params.value != "" && params.value.length > 0 && params.value != "" && params.value.length > 39 ) {
            return <span title={params.value}>{params.value.slice(0, 40).concat("...")}</span>;}
            else{
                 return <span title={params.value}>{params.value}</span>;
                }
        }
        else
            return '-NA-';
    }
    static StringTypeFormatter(params) {
        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';

    }
    static AlarmListFormatter(params) {
        if (params.value != null && params.value != undefined && params.value != '') {
            if (params.value.toString().endsWith(",")) {
                return <span title={params.value.slice(0, -1)}>{params.value.slice(0, -1)}</span>;
            }
            return <span title={params.value}>{params.value}</span>;
        }

        else return "-NA-";
    }

    static StringTypeFormatterFor3P(params) {
        if (params.value != null && params.value != "null" && params.value != undefined && params.value != '' && params.value != '-NA-') {
            if (params.value === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    static RSSITypeFormatter(params) {
        var imageSrc = "";
        if (params.data != null && params.data != undefined) {//WI-21812:For Unknown RSSI Id image is not showing
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    imageSrc = RSSIUNK;
                else if (params.data.RSSI <= -111)
                    imageSrc = RSSI1;
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    imageSrc = RSSI2;
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    imageSrc = RSSI3;
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    imageSrc = RSSI4;
                else if (params.data.RSSI >= -75)
                    imageSrc = RSSI5;
                else
                    imageSrc = RSSIUNK;
            }
            else
                imageSrc = RSSIUNK;//WI-21812:For Unknown RSSI Id image is not showing
        }
        return <span className="reefer-alert"><img src={imageSrc}></img></span>;

    }

    static CommentExistsFormatter(params) {

        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value == 0) {
                return <span className="Trip-edit"><img src={GroupChat}></img></span>;
            }
            else
                return "-NA-";
        }
        return "-NA-";
    }

    static MNCTypeFormatter(params) {
        if (params.value != null && params.value != undefined) {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    static TripWiseStatusFormatter(params, TripWiseStatusList) {
    var TripWiseStatusDescription = '-NA-';
    var TripWiseStatusID = null;
    if (params != null && params != undefined && params.data != null && params.data != undefined && params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() != "D") {
        TripWiseStatusID = params.data.TripWiseStatusID;
 
        if (TripWiseStatusID != null) {
            if (TripWiseStatusList != null && TripWiseStatusList != undefined && TripWiseStatusList.length > 0) {
                var TripWiseStatusId = lodashfilter(TripWiseStatusList, function (item) {
                    return item.TripWiseStatusID === TripWiseStatusID;
                });
                if (TripWiseStatusId != null && TripWiseStatusId.length > 0) {
                    TripWiseStatusDescription = TripWiseStatusId[0].Description;
 
                    if (TripWiseStatusDescription == 'Off') {
                        return <span title="Off" className="fas fa-square GridIcons greytext"></span>;
                    }
                    else if (TripWiseStatusDescription == 'Expired') {
                        return <span title="Expired" className="fas fa-times GridIcons orangetext"> </span>;
                    }
                    else if (TripWiseStatusDescription == 'Check') {
                        return <span title="Check" className="fas fa-exclamation GridIcons color-red"></span>;
                    }
                    else if (TripWiseStatusDescription == 'Passed') {
                        return <span title="Passed" className="fas fa-check GridIcons green-text-color" > </span>;
                    }
                    else if (TripWiseStatusDescription == 'Running') {
                        return <span title="Running" className="fas fa-history GridIcons black-text-color"></span>;
                    }
                    else if (TripWiseStatusDescription == 'Unknown') {
                        return <span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color" ></span>;
                    }
                }
            }
        }
    }
    else {
        if (params != null && params != undefined && params.data != null && params.data != undefined) {
            var DimiState = '-NA-';
            if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "OFF") {
                TripWiseStatusDescription = 'Off';
                return <span title="Off" className="fas fa-square GridIcons greytext"></span>;
            }
            if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "ON") {
                if (params.data.DimiResultActuator == "Passed" && params.data.DimiResultAlarm == "Passed" &&
                    params.data.DimiResultOOR == "Passed" && params.data.DimiResultTerm == "Passed"
                    && params.data.DimiResultValidity == "Passed") {
                    TripWiseStatusDescription= "Passed";
                }
                else if ((params.data.DimiResultValidity == "Failed") && (
                    (params.data.DimiResultActuator == "Passed" || params.data.DimiResultActuator == "Unknown") &&
                    (params.data.DimiResultAlarm == "Passed" || params.data.DimiResultAlarm == "Unknown") &&
                    (params.data.DimiResultOOR == "Passed" || params.data.DimiResultOOR == "Unknown") &&
                    (params.data.DimiResultTerm == "Passed" || params.data.DimiResultTerm == "Unknown"))) {
                    TripWiseStatusDescription= "Expired";
                }
                else if ((params.data.DimiResultActuator == "Unknown" || params.data.DimiResultAlarm == "Unknown"
                    || params.data.DimiResultOOR == "Unknown" || params.data.DimiResultTerm == "Unknown"
                    || params.data.DimiResultValidity == "Unknown") &&
                    (params.data.DimiResultActuator != "Failed" && params.data.DimiResultAlarm != "Failed" &&
                        params.data.DimiResultOOR != "Failed" && params.data.DimiResultTerm != "Failed" &&
                    params.data.DimiResultValidity != "Failed")) {
                    TripWiseStatusDescription= "Unknown";
                }
                else if (params.data.DimiResultActuator == "Failed" || params.data.DimiResultAlarm == "Failed"
                    || params.data.DimiResultOOR == "Failed" || params.data.DimiResultTerm == "Failed") {
                    TripWiseStatusDescription= "Check";
                }
                if (TripWiseStatusDescription == "Check") {
                    var ErrorCount = 0;
                    var text = 'Check – ';
                    if (params.data.DimiResultActuator == "Failed") {
                        ErrorCount = ErrorCount+1;
                        text = text + 'Actuator,';
                    }
                    if (params.data.DimiResultAlarm == "Failed") {
                        ErrorCount = ErrorCount+1;
                        text = text + 'Alarms,';
                    }
                    if (params.data.DimiResultOOR == "Failed") {
                        ErrorCount = ErrorCount+1;
                        text = text + 'Out of Range,';
                    }
                    if (params.data.DimiResultTerm == "Failed") {
                        ErrorCount = ErrorCount + 1;
                        text = text + 'Term,';
                    }
                    if (text.endsWith(",")) {
                        text = text.substring(0, text.length - 1);
                    }
                    if (ErrorCount > 1) {
                        return <span title= {text} className="fas fa-exclamation GridIcons color-red"></span>;
                    }
                    else if (params.data.DimiResultActuator == "Failed") {
                        return <span title= {text} className="fa-light fa-mobile-screen-button fa-rotate-90 mobile-screen-button"></span>;// New icon
                    }
                    else if (params.data.DimiResultAlarm == "Failed") {
                        return <span title= {text} className="fa-solid fa-bell GridIcons color-red"></span>;// New icon
                    }
                    else if (params.data.DimiResultOOR == "Failed") {
                        return <span title= {text} className="fa-sharp fa-solid fa-grip-dots mobile-screen-button"></span>;// New icon
                    }
                    else if (params.data.DimiResultTerm == "Failed") {
                        return <span title={text} className="fa-regular fa-calendar-range color-red calendar-range"></span>;// New icon
                    }
                }
                else if (TripWiseStatusDescription == 'Expired') {
                    return <span title="Expired" className="fas fa-times GridIcons orangetext"> </span>;
                }
                else if (TripWiseStatusDescription == 'Passed') {
                    return <span title="Passed" className="fas fa-check GridIcons green-text-color" > </span>;
                    }
                else if (TripWiseStatusDescription == 'Unknown') {
                    return <span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color" ></span>;
                }
            }
        }
    }
    return TripWiseStatusDescription;
}

    static AlarmDescriptionFormatter(params) {
        var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.AlarmsList != null && params.data.AlarmsList != undefined && params.data.AlarmsList != '') {
                var lstAlarms = params.data.AlarmsList.split(',');
                var alarmsList = params.colDef.refData;
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                        }
                    }
                });
                var almHtmldata = element.innerHTML;
                if (almHtmldata != null && almHtmldata != "") {
                    return <div dangerouslySetInnerHTML={{ __html: almHtmldata }}></div>
                } else {
                    return "-NA-";
                }
                //return element.innerText;
            }

            else return "-NA-";
        }
    }

static CCAlarmDescriptionFormatter(params) {
        var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.CCAlarms != null && params.data.CCAlarms != undefined && params.data.CCAlarms != '') {
                var lstAlarms = params.data.CCAlarms.split(',');
                var alarmsList = params.colDef.refData;
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                        }
                    }
                });
                var almHtmldata = element.innerHTML;
                if (almHtmldata != null && almHtmldata != "") {
                    return <div dangerouslySetInnerHTML={{ __html: almHtmldata }}></div>
                } else {
                    return "-NA-";
                }
                //return element.innerText;
            }

            else return "-NA-";
        }
    }


    static AlarmsDescriptionFormatter(params: any, alarmsList: any) {
        var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.AlarmsList != null && params.data.AlarmsList != undefined && params.data.AlarmsList != '') {
                var lstAlarms = params.data.AlarmsList.split(',');
             /*   var alarmsList = lstAlarms;*/
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                        }
                    }
                });
                var almHtmldata = element.innerHTML;
                if (almHtmldata != null && almHtmldata != "") {
                    return <div dangerouslySetInnerHTML={{ __html: almHtmldata }}></div>
                } else {
                    return "-NA-";
                }
                //return element.innerText;
            }

            else return "-NA-";
        }
    }
    static CCAlertAlarmAliasDescriptionFormatter(params: any, alarmsList: any) {
        if (params.data != null && params.data != undefined) {
            if (params.data.CCAlarms != null && params.data.CCAlarms != undefined && params.data.CCAlarms != '') {
                if (params.data.CCAlarms != "-NA-") {
                    //if (params.data.CCAlarms.toString().endsWith(",")) { //Added if condition code for RCNG-839                        
                    var lstalarmcd: any = params.data.CCAlarms.split(',');
                    var alarmalias: any = "";
                    if(lstalarmcd.length > 0) {
                        $.each(lstalarmcd, function (index, almCd) {
                            var alarm = alarmsList.filter(e => e.AlarmCd === almCd);
                            //if (alarm[0].AlarmAlias != "" && alarm[0].AlarmAlias != null) {
                            if (alarm.length > 0) {//RCNG-2051
                                alarmalias += alarm[0].AlarmAlias + ",";
                            }                            
                        });
                        return <span>{alarmalias.slice(0, -1)}</span>;
                    }

                    var alarmcd = params.data.CCAlarms;
                    var alarm = alarmsList.filter(e => e.AlarmCd === alarmcd);
                    //if (alarm[0].AlarmAlias != "" && alarm[0].AlarmAlias != null) {
                    if (alarm.length > 0) {//RCNG-2051
                        return <span>{alarm[0].AlarmAlias}</span>;
                    }  
                    
                }
                else
                    return '-NA-';
                
            }

            else return "-NA-";
        }
    }
    static CCAlertAlarmsDescriptionFormatter(params: any) {
        if (params.data != null && params.data != undefined) {
            if (params.data.CCAlarms != null && params.data.CCAlarms != undefined && params.data.CCAlarms != '') {
                if (params.data.CCAlarms != "-NA-") {
                    if (params.data.CCAlarms.toString().endsWith(",")) { //Added if condition code for RCNG-839
                        return <span>{params.data.CCAlarms.slice(0, -1)}</span>;
                    }
                   
                    return <span>{params.data.CCAlarms}</span>;
                }
                else
                    return '-NA-';
                
            }

            else return "-NA-";
        }
    }
    static CCAlarmsDescriptionFormatter(params: any, alarmsList: any) {
        var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.CCAlarms != null && params.data.CCAlarms != undefined && params.data.CCAlarms != '') {
                var lstAlarms = params.data.CCAlarms.split(',');
                /*   var alarmsList = lstAlarms;*/
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                if (alarmDescription.length == 0) {//added below condition for RCNG-501
                                    alarmDescription = alarmsList.filter(e =>
                                        e.AlarmCd === item);
                                }
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                        }
                    }
                });
                var almHtmldata = element.innerHTML;
                if (almHtmldata != null && almHtmldata != "") {
                    return <div dangerouslySetInnerHTML={{ __html: almHtmldata }}></div>
                } else {
                    return "-NA-";
                }
                //return element.innerText;
            }

            else return "-NA-";
        }
    }

    static PreTripFormatter(params) {
        if (params.value != null && params.value != undefined) {
            if (params.value.toString().trim() != "-NA-" && params.value.toString().trim() != "") {
                //var element = document.createElement("span");
                //element.className = "reefer-alert-PTI";
                //var imageElement = document.createElement("img");

                if (params.value == 'Passed') {
                    return <span title="Passed" className="fas fa-check GridIcons green-text-color"></span>;
                }
                else if (params.value == 'Failed') {
                    return <span title="Failed" className="fas fa-exclamation GridIcons color-red"> </span>;
                }
                else if (params.value == 'Aborted') {
                    return <span title="Expired" className="fas fa-times GridIcons orangetext "></span>;
                }
                else if (params.value == 'Running') {
                    return <span title="Running" className="fas fa-history GridIcons black-text-color" > </span>;
                }
                else if (params.value == 'Skipped') {
                    return <span title="Skipped" className="fas fa-step-forward GridIcons magenta-color-text "></span>;
                }
                else if (params.value == 'Unknown') {
                    return <span title = "Unknown" className="fas fa-question GridIconsQuestion black-text-color" > </span>;
                }
            }
        }
        return '-NA-';
    }

    static GPSCoordsFormatter(params) {
        if (params.value != null && params.value != '-1000') {
            if (params.data != null && params.data != undefined && params.data != '') {
                if (params.data.DeviceType != null && params.data.DeviceType != undefined && (params.data.DeviceType.toString().toUpperCase().trim() == "GT1200" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1020" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1030")) {
                    if (params.value != null && params.value != '-1000')
                        return params.value;
                    else
                        return '-NA-';
                }
                else if (params.data.GPSLatitude != 0 && params.data.GPSLongitude != 0 && (params.data.GPSLockState == null || params.data.GPSLockState == '' || params.data.GPSLockState.toUpperCase() != "LOCKED")) {
                    if (params.value != null && params.value != '-1000') {
                        //params.value = <i> {params.value}</i>;
                        //params.value = <p style={"color:#736F6E"} ><i> {params.value}</i></p>;
                        var pCss = {
                            'color': '#736F6E'
                        };
                        return <p style={pCss} ><i> {params.value}</i></p>;
                    }
                    else
                        return '-NA-';
                }
                else if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString().trim() == "") {
                    return '-NA-';
                }
                else
                    return params.value;
            }
        }
        else
            return '-NA-';
    }

    static TripWiseFormatter(params) {
        if (params != null && params != undefined && params.data != null && params.data != undefined && params.data.ReeferOemTypeCd != null && params.data.ReeferOemTypeCd != undefined && params.data.ReeferOemTypeCd.toString().toUpperCase().trim() != 'D') {
            switch (params.value) {
                case 0:
                    return <span title="Off" className="fas fa-square GridIcons greytext"></span>;
                case 1:
                    return <span title="Expired" className="fas fa-times GridIcons orangetext "></span>;
                case 2:
                    return <span title="Check" className="fas fa-exclamation GridIcons color-red"></span>;
                case 3:
                    return <span title="Passed" className="fas fa-check GridIcons green-text-color"></span>;
                case 4:
                    return <span title="Running" className="fas fa-history GridIcons black-text-color"></span>;
                case 5:
                    return <span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color"></span>;
                case null:
                    return <span title="-NA-" className="fas fa-horizontal-rule GridIcons black-text-color"></span>;
            }
        }
        else {
            if (params != null && params != undefined && params.data != null && params.data != undefined) {
                var DimiState = '-NA-';
                var TripWiseStatusDescription = '-NA-';
                if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "OFF") {
                    TripWiseStatusDescription = 'Off';
                    return <span title="Off" className="fas fa-square GridIcons greytext"></span>;
                }
                if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "ON") {
                    if (params.data.DimiResultActuator == "Passed" && params.data.DimiResultAlarm == "Passed" &&
                        params.data.DimiResultOOR == "Passed" && params.data.DimiResultTerm == "Passed"
                        && params.data.DimiResultValidity == "Passed") {
                        TripWiseStatusDescription = "Passed";
                    }
                    else if ((params.data.DimiResultValidity == "Failed") && (
                        (params.data.DimiResultActuator == "Passed" || params.data.DimiResultActuator == "Unknown") &&
                        (params.data.DimiResultAlarm == "Passed" || params.data.DimiResultAlarm == "Unknown") &&
                        (params.data.DimiResultOOR == "Passed" || params.data.DimiResultOOR == "Unknown") &&
                        (params.data.DimiResultTerm == "Passed" || params.data.DimiResultTerm == "Unknown"))) {
                        TripWiseStatusDescription = "Expired";
                    }
                    else if ((params.data.DimiResultActuator == "Unknown" || params.data.DimiResultAlarm == "Unknown"
                        || params.data.DimiResultOOR == "Unknown" || params.data.DimiResultTerm == "Unknown") &&
                        (params.data.DimiResultActuator != "Failed" && params.data.DimiResultAlarm != "Failed" &&
                            params.data.DimiResultOOR != "Failed" && params.data.DimiResultTerm != "Failed" &&
                            params.data.DimiResultValidity != "Failed")) {
                        TripWiseStatusDescription = "Unknown";
                    }
                    else if (params.data.DimiResultActuator == "Failed" || params.data.DimiResultAlarm == "Failed"
                        || params.data.DimiResultOOR == "Failed" || params.data.DimiResultTerm == "Failed") {
                        TripWiseStatusDescription = "Check";
                    }
                    if (TripWiseStatusDescription == "Check") {
                        var ErrorCount = 0;
                        var text = 'Check – ';
                        if (params.data.DimiResultActuator == "Failed") {
                            ErrorCount = ErrorCount + 1;
                            text = text + 'Actuator,';
                        }
                        if (params.data.DimiResultAlarm == "Failed") {
                            ErrorCount = ErrorCount + 1;
                            text = text + 'Alarms,';
                        }
                        if (params.data.DimiResultOOR == "Failed") {
                            ErrorCount = ErrorCount + 1;
                            text = text + 'Out of Range,';
                        }
                        if (params.data.DimiResultTerm == "Failed") {
                            ErrorCount = ErrorCount + 1;
                            text = text + 'Term,';
                        }
                        if (text.endsWith(",")) {
                            text = text.substring(0, text.length - 1);
                        }
                        if (ErrorCount > 1) {
                            return <span title={text} className="fas fa-exclamation GridIcons color-red"></span>;
                        }
                        else if (params.data.DimiResultActuator == "Failed") {
                            return <span title={text} className="fa-light fa-mobile-screen-button fa-rotate-90 mobile-screen-button"></span>;// New icon
                        }
                        else if (params.data.DimiResultAlarm == "Failed") {
                            return <span title={text} className="fa-solid fa-bell GridIcons color-red"></span>;// New icon
                        }
                        else if (params.data.DimiResultOOR == "Failed") {
                            return <span title={text} className="fa-sharp fa-solid fa-grip-dots mobile-screen-button"></span>;// New icon
                        }
                        else if (params.data.DimiResultTerm == "Failed") {
                            return <span title={text} className="fa-regular fa-calendar-range color-red calendar-range"></span>;// New icon
                        }
                    }
                    else if (TripWiseStatusDescription == 'Expired') {
                        return <span title="Expired" className="fas fa-times GridIcons orangetext"> </span>;
                    }
                    else if (TripWiseStatusDescription == 'Passed') {
                        return <span title="Passed" className="fas fa-check GridIcons green-text-color" > </span>;
                    }
                    else if (TripWiseStatusDescription == 'Unknown') {
                        return <span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color" ></span>;
                    }
                }
                else
                    return <span title="-NA-" className="fas fa-horizontal-rule GridIcons black-text-color"></span>;
            }
        }
        return <span title="-NA-" className="fas fa-horizontal-rule GridIcons black-text-color"></span>;
    }

    //Grouping formatters starts from here..
    static RunStateFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == 1)
                return <div><span title="Faulty" className="fas fa-power-off GridIcons orangetext"></span><span className="aggrid-run"> Faulty</span></div>;

            else if (param == 2)
                return <div><span title="Running" className="fas fa-power-off GridIcons greenText"></span><span className="aggrid-run"> Running</span></div>;

            else if (param == 3)
                return <div><span title="Standby" className="fas fa-power-off GridIcons greytext"></span><span className="aggrid-run"> Standby</span></div>;

            else if (param == 4)
                return <div><span title="Offline" className="fas fa-horizontal-rule"></span><span className="ps-1"> Offline</span></div>;
            else
                return '*No Run';
        }
    }

    static AssetStateFormatterGrouping(param) {
        if (param != null && param != undefined && param != '') {
            if (param == "A") {
                return <div><span className="ActiveRA"><img src={AssetStateActive} title="Active"></img></span><span className='aggrid-Inv pl-10'> Active</span></div>;
            }
            else if (param == "D") {
                return <div><span className="DisconnectedRA"><img src={AssetStateDisconnected} title="Disconnected"></img></span><span className='aggrid-Inv'> Disconnected</span></div>;
            }
            else if (param == "R") {
                return <div><span className="RetiredRA"><img src={AssetStateRetired} title="Retired"></img></span><span className='aggrid-Inv pl-10'> Retired</span></div>;
            }
        }
        return "*No INV";
    }

    static StatusIndicatorALMFormatterGrouping(param) {
        if (param != null && param != undefined && param != '') {
            if (param == 1) {
                return <div><span className="reefer-alert"><img src={HighALM} title="Severe"></img></span><span className='aggrid-alm'> Severe</span></div>;
            }
            else if (param == 2) {
                return <div><span className="reefer-alert"><img src={MediumALM} title="Minor"></img></span><span className='aggrid-alm'> Minor</span></div>;
            }
            //else if (param == 3) {
            //    return "<span>Informational</span>";
            //}
        }
        return "*No ALM";
    }

    static PowerStateFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == 1) {
                return <div><span className="PlugSolid"><img src={PlugSolid} title="Powered"></img></span><span className='aggrid-pwr'> Powered</span></div>;
            }
            else if (param == 2) {
                return <div><span className="BatteryIndicator"><img src={BatteryIndicator} title="On Battery"></img></span><span className='aggrid-pwr'> On Battery</span></div>;
            }
            else if (param == 3) {
                return <div><span className="DualColorBattery"><img src={DualColorBattery} title="Charging"></img></span><span className='aggrid-pwr'> Charging</span></div>;
            }
            else if (param == 4) {
                return <div><span className="pwr_grid_icon"><img src={batterycritical} title="Critical"></img></span><span className='aggrid-pwr'> Critical</span></div>;
            }
            else if (param == 5) {
                return <div><span className="pwr_grid_icon"><img src={batterylow} title="Low"></img></span><span className='aggrid-pwr'> Low</span></div>;
            }
            else if (param == 6) {
                return <div><span className="pwr_grid_icon"><img src={batterynormal} title="Normal"></img></span><span className='aggrid-pwr'> Normal</span></div>;
            }
            else
                return "*No PWR";
        }
    }

    static CargoCareFormatterGrouping(param) {

        if (param != null && param != undefined) {
            if (param == 1) {
                return <div><span className="reefer-alert"><img src={HighCC} title="Severe"></img></span><span className='aggrid-CellSignal'> Severe</span></div>;
            }
            else if (param == 2) {
                return <div><span className="reefer-alert"><img src={MediumCC} title="Minor"></img></span><span className='aggrid-CellSignal'> Minor</span></div>;
            }
            else if (param == 3) {
                return <div><span className="reefer-alert"><img src={LowCC} title="Informational"></img></span><span className='aggrid-CellSignal'> Informational</span></div>;
            }
            else if (param == 4) {
                return <div><span className="reefer-alert"><img src={NormalCC} title="Assigned"></img></span><span className='aggrid-CellSignal'> Assigned</span></div>; //RCNG-241 Renamed Normal to Assigned
            }
            else if (param == 5) {
                return "*No CC";
            }
        }
        return "*No CC";
    }

    static TripStatusFormatterGrouping(param) {
        var deviationFlg = '';
        if (param != null && param != undefined) {
            var valueString = param.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        return <div><span className="reefer-alert"><img src={TripInprogress} title="In Progress"></img></span><span className='ps-1'> In Progress</span></div>;
                    case 'C':
                        if (deviationFlg == "True")
                            return <div><span className="reefer-alert"><img src={TripCompletedDeviation} title="Completed Deviation"></img></span><span className='ps-1'> Completed Deviation</span></div>;
                        else
                            return <div><span className="reefer-alert"><img src={TripCompleted} title="Completed"></img></span><span className='ps-1'> Completed</span></div>;

                    case 'D':
                        return <div><span className="reefer-alert"><img src={TripProblemetic} title="Problemetic"></img></span><span className='ps-1'> Problemetic</span></div>;
                    case 'P':
                        return <div><span className="reefer-alert"><img src={TripPending} title="Pending"></img></span><span className='ps-1'> Pending</span></div>;
                    case 'R':
                        return <div><span className="reefer-alert"><img src={TripDeleted} title="Deleted"></img></span><span className='ps-1'> Deleted</span></div>;
                    case 'X':
                        if (deviationFlg == "True")
                            return <div><span className="reefer-alert"><img src={TripCancelDeviation} title="Cancel Deviation"></img></span><span className='ps-1'> Cancel Deviation</span></div>;
                        else
                            return <div><span className="reefer-alert"><img src={TripCancel} title="Cancel"></img></span><span className='ps-1'> Cancel</span></div>;
                    default:
                        return "*No Trip";

                }
            }
            return "*No Trip";
        }
        return "*No Trip";
    }

    static RSSIFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == 1)
                return <div><span className="reefer-alert"><img src={RSSI5} title="5 Bars"></img></span><span className='aggrid-CellSignal'> 5 Bars</span></div>;
            else if (param == 2)
                return <div><span className="reefer-alert"><img src={RSSI4} title="4 Bars"></img></span><span className='aggrid-CellSignal'> 4 Bars</span></div>;
            else if (param == 3)
                return <div><span className="reefer-alert"><img src={RSSI3} title="3 Bars"></img></span><span className='aggrid-CellSignal'> 3 Bars</span></div>;
            else if (param == 4)
                return <div><span className="reefer-alert"><img src={RSSI2} title="2 Bars"></img></span><span className='aggrid-CellSignal'> 2 Bars</span></div>;
            else if (param == 5)
                return <div><span className="reefer-alert"><img src={RSSI1} title="1 Bar"></img></span><span className='aggrid-CellSignal'> 1 Bar</span></div>;
            else
                return <div><span className="reefer-alert"><img src={RSSIUNK} title="Unknown"></img></span><span className='aggrid-CellSignal'> Unknown</span></div>;
        }
    }

    static CommentExistsGrouping(params) {
        if (params != null && params != '-NA-') {
            if (params.toString() == "0")
                return <div><span className="reefer-alert"><img src={GroupChat} title="yes"></img></span><span className='aggrid-CellSignal'> yes</span></div>;
            else
                return "*No Comments";
        }
        else
            return '*No Comments';
    }

    static PTResultGrouping(param) {
        if (param != null && param != undefined && param != "null") {

            if (param == 'Passed') {
                return <div><span title="Passed" className="fas fa-check GridIcons green-text-color"></span><span className='ptTWpadding'> Passed</span></div>;
            }
            else if (param == 'Failed') {
                return <div><span title="Failed" className="fas fa-exclamation GridIcons color-red"> </span><span className='ptTWpadding'> Failed</span></div>;
            }
            else if (param == 'Aborted') {
                return <div><span title="Expired" className="fas fa-times GridIcons orangetext"></span><span className='ptTWpadding'> Aborted</span></div>;
            }
            else if (param == 'Running') {
                return <div><span title="Running" className="fas fa-history GridIcons black-text-color"></span><span className='ptTWpadding'> Running</span></div>;
            }
            else if (param == 'Skipped') {
                return <div><span title="Skipped" className="fas fa-step-forward GridIcons magenta-color-text"></span><span className='ptTWpadding'> Skipped</span></div>;
            }
            else if (param == 'Unknown') {
                return <div><span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color"> </span><span className='ptTWpadding'> Unknown</span></div>;
            }

        }
        return "No PTResult";
    }

    static TripWiseStatusGrouping(fieldValue,ReeferOEMTypeCd,DimiResultActuator,DimiResultAlarm,DimiResultOOR,DimiResultTerm) {
    if (fieldValue != null && fieldValue != undefined && fieldValue != "null") {
        switch (fieldValue) {
            case 'Off':
                return <div><span title="Off" className="fas fa-square GridIcons greytext"></span><span className='ptTWpadding'> Off</span></div>;
            case 'Expired':
                return <div><span title="Expired" className="fas fa-times GridIcons orangetext "></span><span className='ptTWpadding'> Expired</span></div>;
            case 'Check':
               //if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd!=null &&params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd.toUpperCase().trim() != "D")
               // return <div><span title="Check" className="fas fa-exclamation GridIcons color-red"></span><span className='ptTWpadding'> Check</span></div>;
                //if (ReeferOEMTypeCd!=null && ReeferOEMTypeCd.toUpperCase().trim() != "D")
                    return <div><span title="Check" className="fas fa-exclamation GridIcons color-red"></span><span className='ptTWpadding'> Check</span></div>;
                //else {
                //        var ErrorCount = 0;
                //        var text = 'Check – ';
                //        if (DimiResultActuator == "Failed") {
                //            ErrorCount = ErrorCount+1;
                //            text = text + 'Actuator,';
                //        }
                //        if (DimiResultAlarm == "Failed") {
                //            ErrorCount = ErrorCount+1;
                //            text = text + 'Alarms,';
                //        }
                //        if (DimiResultOOR == "Failed") {
                //            ErrorCount = ErrorCount+1;
                //            text = text + 'Out of Range,';
                //        }
                //        if (DimiResultTerm == "Failed") {
                //            ErrorCount = ErrorCount + 1;
                //            text = text + 'Term,';
                //        }
                //        if (text.endsWith(",")) {
                //            text = text.substring(0, text.length - 1);
                //        }
                //        if (ErrorCount > 1) {
                //            return <div><span title={text} className="fas fa-exclamation GridIcons color-red"></span><span className='ptTWpadding'> Check</span></div>;
                //        }
                //        else if (ErrorCount >= 1 && fieldValue == 'Check') {
                //            return <div><span title={text} className="fas fa-exclamation GridIcons color-red"></span><span className='ptTWpadding'> Check</span></div>;
                //        }
                //        else if (DimiResultActuator == "Failed") {
                //            return <div><span title={text} className="fa-light fa-mobile-screen-button fa-rotate-90 mobile-screen-button"></span><span className='ptTWpadding'> Check</span></div>;// New icon
                //        }
                //        else if (DimiResultAlarm == "Failed") {
                //            return <div><span title={text} className="fa-solid fa-bell GridIcons color-red"></span><span className='ptTWpadding'> Check</span></div>;// New icon
                //        }
                //        else if (DimiResultOOR == "Failed") {
                //            return <div><span title={text} className="fa-sharp fa-solid fa-grip-dots mobile-screen-button"></span><span className='ptTWpadding'> Check</span></div>;// New icon
                //        }
                //        else if (DimiResultTerm == "Failed") {
                //            return <div><span title={text} className="fa-sharp fa-solid fa-grip-dots mobile-screen-button"></span><span className='ptTWpadding'> Check</span></div>;// New icon
                //        }
                //}
 
            case 'Passed':
                return <div><span title="Passed" className="fas fa-check GridIcons green-text-color"></span><span className='ptTWpadding'> Passed</span></div>;
            case 'Running':
                return <div><span title="Running" className="fas fa-history GridIcons black-text-color"></span><span className='ptTWpadding'> Running</span></div>;
            case 'Unknown':
                return <div><span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color"></span><span className='ptTWpadding'> Unknown</span></div>;
        }
    }
}

    static TripWiseGrouping(fieldValue, ReeferOemTypeCd, DimiResultActuator, DimiResultAlarm, DimiResultOOR, DimiResultTerm, DimiMode, DimiResultValidity) {
        

        if (fieldValue != null && fieldValue != undefined && fieldValue != "null") {
            {
                switch (fieldValue.toString()) {//Updated for RCNG 5364
                    case 'Off': case '0':
                        return <div><span title="Off" className="fas fa-square GridIcons greytext"></span><span className='ptTWpadding'>Off</span></div>;
                    case 'Expired': case '1':
                        return <div><span title="Expired" className="fas fa-times GridIcons orangetext "></span><span className='ptTWpadding'>Expired</span></div>;
                    case 'Check': case '2':
                        return <div><span title="Check" className="fas fa-exclamation GridIcons color-red"></span><span className='ptTWpadding'>Check</span></div>;
                    case 'Passed': case '3':
                        return <div><span title="Passed" className="fas fa-check GridIcons green-text-color"></span><span className='ptTWpadding'>Passed</span></div>;
                    case 'Running': case '4':
                        return <div><span title="Running" className="fas fa-history GridIcons black-text-color"></span><span className='ptTWpadding'>Running</span></div>;
                    case 'Unknown': case '5':
                        return <div><span title="Unknown" className="fas fa-question GridIconsQuestion black-text-color"></span><span className='ptTWpadding'>Unknown</span></div>;

                }
            }
        }
    }
    static statusIndicatorforALM(params) {
        if (params.value != null && params.value != undefined && params.value != '') {
            switch (params.value.trim()) {
                case '1':
                    return <span className="reefer-alert"><img src={HighALM}></img></span>;
                case '2':
                    return <span className="reefer-alert"><img src={MediumALM}></img></span>;
            }
        }
        return <span className="reefer-alert"></span>;
    }
    static CommandValidator(params) {
        if (params.value != null && params.value != undefined) {
            switch (params.value.toString().trim()) {
                case 'E': case 'U':
                    return <span className="reefer-alert"><img src={ImgPending1}></img></span>;
                case 'W':
                    return <span className="reefer-alert"><img src={ImgWarning1}></img></span>;
                default:
                    return <span className="reefer-alert"><img src={ImgSuccess1}></img></span>;
            }
        }
        return <span className="reefer-alert"></span>;
    }
    static removeIndicator(params: any) {
        return <span className="reefer-delete"><img src={deletepng} title='Remove' onClick={(e: any) => {
            params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
            params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
        }}></img></span>;
    }
    static commandLogStatusFormatter(params) {
        if (params != null && params != undefined) {
            if (params.data.Status != null && params.data.Status != undefined && params.data.Status != '') {
                var imageElement = document.createElement("img");

                switch (params.data.Status.toString().toUpperCase().trim()) {

                    case "UNKNOWN":
                        return <span className="reefer-alert"><img src={UnknownStatus}></img></span>;
                    case "ERROR":
                        return <span className="reefer-alert"><img src={ErrorStatus}></img></span>;
                    case "PENDING":
                        return <span className="reefer-alert"><img src={PendingStatus}></img></span>;
                    case "ISSUED":
                        return <span className="reefer-alert"><img src={IssuedStatus}></img></span>;
                    case "EXPIRED":
                        return <span className="reefer-alert"><img src={ExpiredStatus}></img></span>;
                    case "CANCELLED":
                        return <span className="reefer-alert"><img src={CancelStatus}></img></span>;
                    case "SUCCESS":
                        return <span className="reefer-alert"><img src={SucessStatus}></img></span>;
                    case "COMMANDACCEPTEDBYRCD":
                        return <span className="reefer-alert"><img src={AcceptedStatus}></img></span>;
                    case "REJECTED":
                        return <span className="reefer-alert"><img src={RejectedStatus}></img></span>;
                    case "DISCARDED":
                        return <span className="reefer-alert"><img src={DiscardedStatus}></img></span>;
                    case "RETRY":
                        return <span className="reefer-alert"><img src={RetryStatus}></img></span>;
                    case "COMMANDACCEPTEDBYBUSYRCD":
                        return <span className="reefer-alert"><img src={AcceptedByBusyRCDStatus}></img></span>;
                    case "AWAITINGPREREQUISITES":
                        return <span className="reefer-alert"><img src={AwaitingPrerequisites}></img></span>;
                    case "CANCELLATIONREQUEST":
                        return <span className="reefer-alert"><img src={CancellationRequest}></img></span>;
                    case "AWAITINGSYNC":
                        return <span className="reefer-alert"><img src={PendingStatus}></img></span>;
                    case "SENTTOVC":
                        return <span className="reefer-alert"><img src={SendToVC}></img></span>;
                    case "SYNCERROR":
                        return <span className="reefer-alert"><img src={ErrorStatus}></img></span>;
                    case "SYNCCANCELLED":
                        return <span className="reefer-alert"><img src={CancelStatus}></img></span>;
                    case "VALIDATIONPENDING":
                        return <span className="reefer-alert"><img src={ValidationPendingStatus}></img></span>;
                    case "UNDELIVERABLE":
                        return <span className="reefer-alert"><img src={UndeliverableStatus}></img></span>;
                    default:
                        break;
                }
            }
            return <span className="reefer-alert"></span>;
        }

        return <span className="reefer-alert"></span>;
    }

    static CommandTypeFormatter(params) {
        if (params.value != null && params.value != undefined && params.value != '') {
            if (params.value) {
                return <span className="reefer-alert"><img src={bulletcommand}></img></span>;
            }
            else
                return <span className="reefer-alert"></span>;
        }
        return <span className="reefer-alert"></span>;
    }

    static AlarmDescriptionGroupingFormatter(param, DeviceType, alarmsList) {
        var element = document.createElement("span");
        if (param != null && param != undefined) {
            if (param != null && param != undefined && param != '') {
                var lstAlarms = param.split(',');
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (DeviceType != null && DeviceType != undefined && DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                        }
                    }
                });

                return element.innerText;
            }

            else return "-NA-";
        }
    }

    /* Start RCNG 243*/
    static TemperatureUnitFormatter(params) {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.value != null && params.value != undefined && params.value != '' && params.value != null && params.value != undefined) {         
                var tempUnitDescription;
                if (params.value == "F")
                    tempUnitDescription = "Fahrenheit";
                else if (params.value == "C")
                    tempUnitDescription = "Celsius";
                else
                    tempUnitDescription = "NOnRunning";
                return <span>{tempUnitDescription}</span>;
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    }

    static CargoCareProfileFormatter(params) {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.value != null && params.value != undefined && params.value != '' && params.value != null && params.value != undefined) {
                var cargoCareProfile;
                /* if (params.value == "DEFAULT") //Commented below code for RCNG-792
                    cargoCareProfile = "DEFAULT";
                else
                    cargoCareProfile = '-NA-';*/
                cargoCareProfile = params.value; // Added this code for RCNG-792
                return <span>{cargoCareProfile}</span>;
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    }

    static isHighValueCargoFormatter(params) {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.value != null && params.value != undefined && params.value != null && params.value != undefined) {
                var highValueCargo;
                if (params.value.toString().toUpperCase().trim() == "0" || params.value.toString().toUpperCase().trim() == "FALSE") {
                    highValueCargo = "No";
                }
                else if (params.value.toString().toUpperCase().trim() == "1" || params.value.toString().toUpperCase().trim() == "TRUE") {
                    highValueCargo = "Yes";
                }
                else
                    highValueCargo = '-NA-';
                return <span>{highValueCargo}</span>;
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    }
    /* End RCNG 243*/
    static BatteryPctFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.DeviceType != null && params.data.DeviceType != "" && params.data.DeviceType != undefined) {
                if (params.data.DeviceType.trim() == "CT3600" && params.data.ReeferBatteryPct != null && params.data.ReeferBatteryPct != undefined && params.data.ReeferBatteryPct >= 0) {
                    var battPct = (Math.round(params.data.ReeferBatteryPct / 10.0)) * 10;

                    switch (battPct) {
                        case 0:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP0}></img></span>;
                        case 10:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP10}></img></span>;
                        case 20:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP20}></img></span>;
                        case 30:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP30}></img></span>;
                        case 40:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP40}></img></span>;
                        case 50:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP50}></img></span>;
                        case 60:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP60}></img></span>;
                        case 70:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP70}></img></span>;
                        case 80:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP80}></img></span>;
                        case 90:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP90}></img></span>;
                        case 100:
                            return <span className="pwr_grid_icon" title={params.data.ReeferBatteryPct}><img src={DBP100}></img></span>;
                    }
                }
            }
        }
        return '-NA-';
    }
    static ReeferDoorBattPctFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == "-1") return '*No batt';
            else {
                switch (param.toString()) {
                    case "0":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP0} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "10":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP10} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "20":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP20} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "30":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP30} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "40":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP40} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "50":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP50} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "60":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP60} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "70":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP70} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "80":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP80} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "90":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP90} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "100":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP100} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                }
            }
        }
    }
}
